import { APICore } from 'helpers/api/apiCore'
import { ModeloMensagem } from 'models/backoffice/criarModeloChatWoot/types'

const api = new APICore()

export function getAllModelosMensagensChatWoot(params: {
  pagina: number
  registros: number
  limiteMaximoRegistros: number
}) {
  return api.get(`ModelosMensagens/paginado`, {
    pagina: params.pagina + 1,
    registros: params.registros,
    limiteMaximoRegistros: params.limiteMaximoRegistros
  })
}

export function createModeloMensagemChatWoot(
  atalho: string,
  descricao: string
) {
  return api.create(`ModelosMensagens`, {
    atalho,
    descricao
  })
}
export function deleteModeloMensagemChatWoot(id: string) {
  return api.delete(`ModelosMensagens/${id}`)
}

export function updateModeloMensagemChatWoot(params: ModeloMensagem) {
  return api.update(`ModelosMensagens`, params)
}
export function getByIdModeloMensagemChatWoot(id: string) {
  return api.get(`ModelosMensagens/byId/${id}`)
}
export function getfiltro(filtro: string) {
  return api.get(`ModelosMensagens/filtro`, {
    filtro
  })
}
export function getModelosMensagemChatWoot() {
  return api.get(`ModelosMensagens`, null)
}
